import { __extends } from "tslib";
import config from '../config';
import Flow from './Flow';
import DatePickerPlugin from '../plugins/DatePicker';
import TimeTablePlugin from '../plugins/TimeTable';
import CalendarService from '../service/Calendar';
var ChooseDate = /*@__PURE__*/ (function (_super) {
    __extends(ChooseDate, _super);
    function ChooseDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.init = function () {
            _this.timeslots = [];
            _this.setRoamingStepperItem(config.appointman.flow.CHOOSE_DATE);
            _this.initDatePicker();
            _this.initTimeTable();
            if (_this.getState().CURRENT_FLOW === config.appointman.flow.CHOOSE_DATE) {
                _this.activate();
            }
            _this.registerEventListeners();
            _this.flow = _this.getState().CURRENT_FLOW;
            _this.loadingElement = jQuery(_this.getElement()).find('.appointment-picker .loading-indicator').get(0);
            _this.uiPickerElement = jQuery(_this.getElement()).find('.appointment-picker .ui-picker').get(0);
            _this.uiPickerFailedElement = jQuery(_this.getElement()).find('.appointment-picker .ui-picker-failed').get(0);
            if (_this.getState().date && _this.getState().dateLabel) {
                if (_this.getState().dateLabel.length > 0) {
                    _this.getItem().setComplete(true);
                    _this.getItem().setLabel(_this.buildPreviewLabel());
                }
            }
        };
        _this.initTimeTable = function () {
            var element = jQuery(_this.getElement()).find('.mod-timetable').get(0);
            _this.timeTable = new TimeTablePlugin(element);
        };
        _this.initDatePicker = function () {
            var element = jQuery(_this.getElement()).find('.fm-date-picker-grid').get(0);
            _this.datePicker = new DatePickerPlugin(element);
        };
        _this.transform2Digits = function (decimal) {
            var formattedNumber = ("0" + decimal.toString()).slice(-2);
            return formattedNumber;
        };
        _this.registerEventListeners = function () {
            _this.datePicker.onDateChange(function (date, label) {
                _this.timeTable.activateLoadingState();
                var dateTomorrow = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
                var startDate = _this.transform2Digits(date.getDate()) + "." + _this.transform2Digits(date.getMonth() + 1) + "." + date.getFullYear();
                _this.setState({
                    date: date,
                    dateLabel: label,
                    timeslot: false
                });
                var timeslots = _this.timeslots[startDate];
                for (var _i = 0, timeslots_1 = timeslots; _i < timeslots_1.length; _i++) {
                    var set = timeslots_1[_i];
                    if (set.appointmenttype === _this.getState().apmType) {
                        var timeslotLength = set.appointmentlength;
                        var timeslotItems = set.timeslots;
                        _this.timeTable.load(timeslotItems, timeslotLength);
                    }
                }
            });
            _this.timeTable.onChangeTimeSlot(function (timeslot, index) {
                _this.setState({
                    timeslot: timeslot
                });
            });
            _this.getItem().onChangeRequest(function () {
                _this.setState({
                    CURRENT_FLOW: config.appointman.flow.CHOOSE_DATE
                });
                _this.getItem().setComplete(false);
                _this.getItem().setLabel(_this.buildActiveLabel());
            });
        };
        _this.hideUIPickers = function () {
            jQuery(_this.uiPickerElement)
                .removeClass('loaded')
                .removeClass('start-loading');
            jQuery(_this.uiPickerFailedElement)
                .removeClass('loaded')
                .removeClass('start-loading');
        };
        _this.retrieveSlots = function () {
            _this.timeTable.disable();
            _this.activateLoadingState();
            _this.disableNextButton();
            var date = new Date();
            var endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 31);
            var startDateString = _this.transform2Digits(date.getDate()) + "." + _this.transform2Digits(date.getMonth() + 1) + "." + date.getFullYear();
            var endDateString = _this.transform2Digits(endDate.getDate()) + "." + _this.transform2Digits(endDate.getMonth() + 1) + "." + endDate.getFullYear();
            CalendarService
                .getFreeslotsByApmType(_this.getState().rmsID, startDateString, endDateString, _this.getState().apmType)
                .then(function (res) {
                var result = res[_this.getState().rmsID];
                var availability = result.availability;
                _this.timeslots = availability;
                _this.deactivateLoadingState(true);
                _this.datePicker.enableDates(_this.extractDates(_this.timeslots));
                setTimeout(function () {
                    _this.datePicker.activateFirstDateCell();
                }, 100);
            })
                .catch(function () {
                _this.deactivateLoadingState(false);
            });
        };
        _this.extractDates = function (timeslots) {
            var dates = [];
            for (var date in timeslots) {
                dates.push(date);
            }
            return dates;
        };
        _this.activateLoadingState = function () {
            jQuery(_this.uiPickerElement)
                .removeClass('loaded');
            jQuery(_this.uiPickerFailedElement)
                .removeClass('loaded');
            jQuery(_this.loadingElement)
                .addClass('start-loading');
            setTimeout(function () {
                jQuery(_this.loadingElement)
                    .addClass('loaded');
            }, 0);
            setTimeout(function () {
                jQuery(_this.uiPickerElement)
                    .removeClass('start-loading');
                jQuery(_this.uiPickerFailedElement)
                    .removeClass('start-loading');
            }, 250);
        };
        _this.deactivateLoadingState = function (success) {
            _this.hideUIPickers();
            var targetElement = !success ? _this.uiPickerFailedElement : _this.uiPickerElement;
            jQuery(targetElement)
                .addClass('start-loading');
            jQuery(_this.loadingElement)
                .removeClass('loaded');
            setTimeout(function () {
                jQuery(targetElement)
                    .addClass('loaded');
            }, 5);
            setTimeout(function () {
                jQuery(_this.loadingElement)
                    .removeClass('start-loading');
            }, 250);
        };
        return _this;
    }
    ChooseDate.prototype.onStateChange = function () {
        var state = this.getState();
        if (state.date && state.timeslot) {
            this.enableNextButton();
        }
        else {
            this.disableNextButton();
        }
        if (state.CURRENT_FLOW === config.appointman.flow.CHOOSE_DATE) {
            if (this.flow !== state.CURRENT_FLOW) {
                this.flow = state.CURRENT_FLOW;
                this.hideUIPickers();
                this.retrieveSlots();
                this.activate();
            }
        }
        else {
            this.flow = state.CURRENT_FLOW;
        }
    };
    ChooseDate.prototype.onNextRequest = function () {
        var beautifiedDate = this.buildPreviewLabel();
        this.setState({
            CURRENT_FLOW: config.appointman.flow.CONTACT_DETAILS
        });
        this.getItem().setComplete(true);
        this.getItem().setLabel(beautifiedDate);
    };
    ChooseDate.prototype.buildPreviewLabel = function () {
        var html = ChooseDate.PREVIEW_LABEL_HTML;
        var value = this.getState().dateLabel + " / " + this.getState().timeslot;
        html = html.replace('%s', value);
        return html;
    };
    ChooseDate.prototype.buildActiveLabel = function () {
        var html = ChooseDate.ACTIVE_LABEL_HTML;
        return html;
    };
    ChooseDate.PREVIEW_LABEL_HTML = config.appointman.msg.CHOOSE_DATE_PREVIEW;
    ChooseDate.ACTIVE_LABEL_HTML = config.appointman.msg.CHOOSE_DATE_ACTIVE;
    return ChooseDate;
}(Flow));
export default ChooseDate;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/flow/ChooseDate.ts
// module id = null
// module chunks = 